import { POST, GET } from '@/utils/request'
import Api from './url'

export const getCourierValueExplain = async (params: object) => {
  return await GET({
    url: Api.getCourierValueExplain,
    params
  })
}
